export const MAX_ALLOWED_COMMUNITIES = 3;

export const MAX_PINNED_POSTS = 5;
